export default __webpack_public_path__ + "static/media/30.a77edf1f.png";